import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { ChevronDown } from 'lucide-react'

export default function SelectChampionshipSplitsButton({
  selectedSplits,
  setSelectedSplits,
  splits,
  disabled = false,
}) {
  const selectedSplitValues = Array.isArray(selectedSplits)
    ? selectedSplits
    : []
  const splitList = Array.isArray(splits) ? splits : []

  const setValue = (splitId) => {
    const splitIsSelected = selectedSplitValues.find((val) => val === splitId)

    const newValues = splitIsSelected
      ? selectedSplitValues.filter((val) => val !== splitId)
      : [...selectedSplitValues, splitId]

    setSelectedSplits(newValues)
  }

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          disabled={disabled}
          variant="outline"
          className="flex items-center gap-1"
        >
          <div className="mr-[10px] flex items-center">
            {splitList.map((split, index) => {
              const currentSplitValue = selectedSplitValues.find(
                (val) => val === split.id,
              )

              if (!currentSplitValue) return null

              return (
                <div
                  key={index}
                  className="mr-[-7px] h-[11px] w-[11px] rounded-full"
                  style={{
                    backgroundColor: split.color ?? '#ffffff',
                  }}
                ></div>
              )
            })}
          </div>
          <span>
            {selectedSplitValues.length} / {splitList.length}
          </span>
          Splits
          <ChevronDown className="size-4 stroke-shades-0" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent>
        {splitList.map((split, index) => (
          <DropdownMenuItem
            key={`split-${index}`}
            className="flex cursor-pointer items-center gap-2"
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              setValue(split.id)
            }}
          >
            <Checkbox
              checked={selectedSplitValues.some((v) => v === split.id)}
            />

            <div
              className="h-[11px] w-[11px] rounded-full"
              style={{
                backgroundColor: split.color ?? '#ffffff',
              }}
            ></div>

            {split.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
